import type { FaireProductEntity } from "../../entity_types/product";

export const p_9b8v52jkz4: FaireProductEntity = {
  token: "p_9b8v52jkz4",
  type: "product",
  name: "Vera Fairisle Sweater - Walnut",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/08278b6d12b640e8e3d804c6f4fcb36ccd1736c9c10ec333a9ea08e183ae49a8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b4e92f6463fcfcf89a4e4363842389c6bd61d0403a10a44491d37f8ca1d94fa.jpeg",
    "https://cdn.faire.com/fastly/ccedd4d20daaf3d33a5e03616044e4744a314e02d0dca4de7b717e581e974280.jpeg",
    "https://cdn.faire.com/fastly/0c29c784774174502a3789dafd82b225415fc0b4742b9337711e8476befa2a7a.jpeg",
    "https://cdn.faire.com/fastly/3d18da24c38e7e55754f473f20feaeb10b73a4f785530fcb42435a0b39ff2a6d.jpeg",
    "https://cdn.faire.com/fastly/6b87f851f443dd0cd3d975e6ed998a07c54a7a2c1ed19140e2d5032b14ce2818.jpeg",
    "https://cdn.faire.com/fastly/16624e0a59794db20050016d118e768927d778bcaed0a9d44932e017592f896b.jpeg",
    "https://cdn.faire.com/fastly/4c48213b48f8f42d4c30fad5123ff7d5ef4a4baa7f597815f525f623bab96b7a.jpeg",
    "https://cdn.faire.com/fastly/36cc3bc32d5c728db2c00df3c9e1b264df2464a04aaaa238d54f34576e925151.jpeg",
    "https://cdn.faire.com/fastly/4c6c236bed7cd54913b5f6444b40c4bb4823f79296dbeeafb53976bb7db4b571.jpeg"
  ],
  priceDollars: 116.1,
  description: "A modern nod to a timeless knit tradition. The Vera Fairisle Sweater reimagines a classic motif through graphic patternwork meets ultra-soft alpaca warmth.\n\n• 89% Alpaca 11% Polyamide\n• Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity\n• Classic fit with a subtle crop",
  tags: [],
  msrpDollars: 258,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:21.378Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
